import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/meeting/pubMeeting/planLibraryList',params);
    },

    queryMainApplication(params) {
      return common.get('/rocheManage/meeting/pubMeeting/planLibraryMeetingSummary',params);
    },
}


// WEBPACK FOOTER //
// ./src/api/meetingplan/library.js